import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import "./style.css";
import Table from "../TableItems/table";
import { useLocation } from "react-router-dom";
import { PrivilegeContext } from "../../../context/PrivilegesContext";
import { DomainContext } from "../../../context/DomainContext";
import { TableSkeleton } from "../TableItems/table/skeleton";
import { useGenerateSearchFields } from "./Hooks/useGenerateSearchFields";
import ReportTitle from "./ReportTitle";
import { useGetTableData } from "./Hooks/useGetTableData";
import header from "@/pages/auth/components/header";
import { useTranslation } from "react-i18next";

const ReportContent = ({ children, tableAPI, columns }) => {

  const [tableFiller, setTableFiller] = useState({ pageSize: 25, page: 0 });

  const { hiddenColumnsList } = useGenerateSearchFields(columns)

  const { dataLoading } = useContext(DomainContext);

  const { t, i18n } = useTranslation();

  const { data, totalRows } = useGetTableData(tableAPI, tableFiller)

  const { privileges } = useContext(PrivilegeContext);

  const localizedColumns = useMemo(() => columns.map((column) => ({ ...column, Header: t(column.Header) })), [columns, i18n.language])

  return (
    <div className="pages-wrapper">

      {/*  <ReportTitle /> */}
      {children}
      {/**/}
      <Table
        isLoading={dataLoading}
        columns={localizedColumns}
        data={data}
        isNeedFetch={false}
        setTableFiller={setTableFiller}
        tableFiller={tableFiller}
        TotalRows={totalRows}
        hiddenColumns={hiddenColumnsList}
        hideActions={!privileges?.canDelete && !privileges?.canEdit}
      />

      <TableSkeleton isLoading={dataLoading} />

    </div>
  );
};

export default ReportContent;
